var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBookmark = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 12,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#5C5F62",
  d: "M2.9 1.8h6.3v-.35C9.2.87 8.73.4 8.15.4H2.9A2.1 2.1 0 0 0 .8 2.5v8.05c0 .58.47 1.05 1.05 1.05h6.3c.58 0 1.05-.47 1.05-1.05v-6.3c0-.58-.47-1.05-1.05-1.05H7.8v3.5L6.4 5.3 5 6.7V3.2H2.2v-.7a.7.7 0 0 1 .7-.7"
})));
export { SvgBookmark as ReactComponent };
export default __webpack_public_path__ + "static/media/bookmark.4e353bc8.svg";